import http from "./http-common";
import { getAuthToken } from "./authService";
import { getUploadSessionId, UPLOAD_SESSION_HEADER } from "@/utils/uploadSessionId";

// Thin wrapper around the /api/v1/upload/sessions endpoints. All requests are stamped with the
// browser's session id so the backend can decide (1) whether an upload row is owned by this
// device and (2) whether writes from this device should be honoured or 423'd.

const withSessionHeader = async () => {
  const token = await getAuthToken();
  return {
    Authorization: `Bearer ${token}`,
    [UPLOAD_SESSION_HEADER]: getUploadSessionId(),
  };
};

// GET /api/v1/upload/sessions/active
// Returns the contributor's non-terminal uploads (across all devices), plus which of them the
// current session owns. Called on boot and on visibility-wake to surface cross-device state.
export const fetchActiveSessions = async () => {
  const response = await http.get("/api/v1/upload/sessions/active", {
    headers: await withSessionHeader(),
  });
  return response.data;
};

// POST /api/v1/upload/sessions/{uploadId}/claim
// Atomically transfers ownership of the row to the calling session. The previously-owning
// device's next TUS PATCH will 423 and drop into spectator mode; the new owner can then resume
// by re-picking files (bytes on disk are preserved).
export const claimUploadSession = async (uploadId) => {
  const response = await http.post(
    `/api/v1/upload/sessions/${uploadId}/claim`,
    null,
    { headers: await withSessionHeader() },
  );
  return response.data;
};

// GET /api/v1/upload/packages/{uploadId}
// Returns the full package metadata (name, expected files with names+sizes+tus URLs). Used
// after a cross-device claim so the new owner can hydrate its local IndexedDB stub and drop
// into the standard "please re-pick your files" resume UX.
export const fetchPackageMetadata = async (uploadId) => {
  const response = await http.get(`/api/v1/upload/packages/${uploadId}`, {
    headers: await withSessionHeader(),
  });
  return response.data;
};
